/* 
Objetivo:
  Modelo de campo de nombre de usuarrio

Notas:
  No está en uso  
*/

import { types, getSnapshot } from 'mobx-state-tree'

const ModeloTema = types
.model('ModeloInputTema', {
  icon: 'exchange',
  label: 'Tema', 
  name: 'tema',
  type: 'text',
  value: '',
  error: '',
  deshabilitado: false,
  errorRequerido: 'Campo no debe quedar vacío',
  errorLongitud: 'Campo debe ser de 2 a 50 caracteres',
})

.actions (self => ({
  setValor(value) {
    self.value = value
    self.error = ''
  },

  validar() {
    if (self.value == '') {
      self.error = self.errorRequerido
      return
    }

    if (self.value.length < 2 || self.value.length > 50) {
      self.error = self.errorLongitud
      return
    }
  }

}))

.views (self => ({ 

  getPropiedades () {
    return  getSnapshot(self)
  }

})) //fin views

export default  ModeloTema